






















import { Prop, Vue, Component } from 'vue-property-decorator';
import { mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbCol, mdbIcon, mdbInput, mdbRow, mdbTooltip } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCol,
        mdbIcon,
        mdbInput,
        mdbRow,
        mdbTooltip
    }
})
export default class ExternalLinks extends Vue {
    @Prop(Array) private links!: [];
    @Prop(Boolean) private canWrite!: boolean;
    @Prop(Boolean) private pageContentLoaded!: boolean;

    private editFrontPageOtherLinks(): void {
        this.$emit('clicked-edit-external-links');
    }
}
